//@ts-check
export const migrationFunctions = {
  // this migration renames all cp ids to be `cp_{{timestamp}}` instead of `cp_{{index integer}}`
  // it also adds 'vitalsCheckpoints.{}.time': 'timestamp'
  1: caseData => {
    const {
      vitalsCheckpoints,
      vitalRecords,
      autoVitalRecords,
      events,
      vitalsInterval,
      customEvents,
    } = caseData
    const { caseStart } = events || {}
    if (!caseStart) {
      return null
    }
    if (
      !vitalsCheckpoints &&
      !vitalRecords &&
      !autoVitalRecords &&
      !customEvents
    ) {
      return null
    }

    const intervalInMilliseconds = (vitalsInterval || 5) * 60000

    const getCheckpointTimeForInt = int => {
      // if we get a high value here, the update has already been applied
      if (int > 1000) {
        return int
      }
      return int * intervalInMilliseconds + caseStart
    }

    const getIntFromName = name => Number(name.split('_')[1])

    const getNewCheckpointName = name =>
      `cp_${getCheckpointTimeForInt(getIntFromName(name))}`

    const keysWithCheckpoints = [
      'vitalsCheckpoints',
      'vitalRecords',
      'autoVitalRecords',
    ]
    let changes = {}
    for (const key of keysWithCheckpoints) {
      for (const cpName in caseData[key]) {
        const value = caseData[key][cpName]
        changes[`${key}.${cpName}`] = null
        const checkpointInt = getIntFromName(cpName)
        const time = getCheckpointTimeForInt(checkpointInt)
        const newName = `cp_${time}`
        // this one we also add the time
        if (key === 'vitalsCheckpoints') {
          changes[`vitalsCheckpoints.${newName}`] = {
            complete: !!value.complete,
            time,
          }
        } else {
          changes[`${key}.${newName}`] = value
        }
      }
    }

    if (customEvents) {
      for (const id in customEvents) {
        const event = customEvents[id]
        if (event.checkpointId) {
          changes[`customEvents.${id}.checkpointId`] = getNewCheckpointName(
            event.checkpointId
          )
        }
      }
    }

    return changes
  },
}
